<template>
  <div class="review-container">
    <div class="top-bar">
      <img class="logo" src="https://cdn.spbcn.org/spbcnWeb/pbl/PBLLOGO.png" alt="">
      <div>
        <div class="tit1 font-h1">2026全球青少年PBL创新素养挑战赛</div>
        <div class="tit1 font-h1">评分系统</div>
      </div>
    </div>
    <div class="container">
      <el-row :gutter="20">
        <el-col :span="isMobile ? 24 : 8" v-for="(item, index) in list" :key="index">
          <div class="box">
            <div class="tit">
              <div class="key font-d1">项目方向</div>
              <div class="val font-d2">{{ item.theme }}</div>
            </div>
            <div class="title2">
              <div class="key font-d1">项目名称</div>
              <div class="val font-d2">{{ item.name }}</div>
            </div>
            <div class="flex">
              <div class="title2">
                <div class="key font-d1">队伍名称</div>
                <div class="val font-d2">{{ item.teamName }}</div>
              </div>
              <div class="title2">
                <div class="key font-d1">队伍组别</div>
                <div class="val font-d2">{{ formatLevel(item.schoolLevel) }}</div>
              </div>
            </div>
            <div class="flex">
              <div class="btn-con font-d2" @click="nextFn('process', item.id)">
                <div>
                  过程性评价
                </div>
                <div class="btn">点击评价</div>
              </div>
              <div class="btn-con font-d2" @click="nextFn('summative', item.id)">
                <div>
                  终结性评价
                </div>
                <div class="btn">点击评价</div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      code: this.$route.query.code,
      dict_schoolGroup: this.$curUtils.dict_schoolGroup(),
      list: [],
      // true = 手机端，false = PC 端
      isMobile: false
    }
  },
  created () {
    document.title = 'GYPIC 评分系统'
    this.checkDevice()
    this.getList()
  },
  methods: {
    // 判断打开窗口是手机端还是 PC 端（结果存入 this.isMobile，同时返回布尔值）
    checkDevice () {
      const ua = navigator.userAgent
      // 常见移动端 UA 关键字
      const isMobileUa = /Android|iPhone|iPad|iPod|Windows Phone|webOS|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(ua)
      // iPadOS 13+ 默认以桌面 Safari UA 访问，UA 里没有 iPad，用「Mac 平台 + 多点触控」兜底识别
      const isIpadOs = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
      this.isMobile = isMobileUa || isIpadOs
      return this.isMobile
    },
    getList () {
      this.$http.get('common/pblJudge/pblTeamPage?pageNum=1&pageSize=100&status=1&judgeCode=' + this.code).then(res => {
        if (res.code === 200) {
          this.list = res.data.list
        }
      })
    },
    nextFn (type, id) {
      this.$router.push(`/reviewDetail?type=${type}&code=${this.code}&pblTeamId=${id}`)
    },
    formatLevel (level) {
      return this.dict_schoolGroup.find(item => item.dictValue === level).dictLabel
    }
  }
}
</script>
<style lang="less" scoped>
.review-container{
  background-color: #EAEAEA;
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
}
/**字号集中处理 */
.font-h1{
  font-size: 52px;
  line-height: 52px;
}
.font-h2{
  font-size: 40px;
}
.font-d1{
  font-size: 30px;
}
.font-d2{
  font-size: 48px;
}

.top-bar{
  width: 100vw;
  height: 220px;
  background-image: url(https://cdn.spbcn.org/spbcnWeb/pbl/top-bg.png);
  background-position: center;
  background-size: cover;
  box-sizing: border-box;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px;
  .logo{
    height: 100px;
  }
}
.tit1{
  color: #fff;
  font-family: systh;
  margin-bottom: 20px;
  text-align: right;
}
.container{
  padding: 20px 40px;
}
.key{
  color: #666;
}
.val{
  font-family: systh;
}
.box{
  background-color: #fff;
  border-radius: 20px;
  margin-bottom: 80px;
  .tit{
    background-color: #C9273A;
    border-radius: 16px 16px 0 0;
    color: #fff;
    padding: 20px 40px;
    margin-bottom: 20px;
    .key{
      color: #FD8E86;
    }
  }
  .title2{
    margin: 10px 40px 30px;
  }
  .bt{
    border-top: 1px solid #ddd;
    padding-top: 20px;
  }
  .flex{
    display: flex;
    justify-content: space-between;
  }
  .btn-con{
    background-color: #EAEAEA;
    color: #000;
    font-family: systh;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 40px;
    border-radius: 20px;
    padding-left: 30px;
  }
  .btn{
    background-color: #C9273A;
    color: #fff;
    border-radius: 20px;
    cursor: pointer;
    height: 100px;
    padding: 0 20px;
    line-height: 96px;
    text-align: center;
    font-family: systh;
    margin: 14px;
  }
  .tag{
    margin: 20px;
    width: 400px;
    text-align: center;
  }
}
@media (min-width: 768px) {
  .font-h1{
    font-size: 22px;
    line-height: 22px;
  }
  .font-d1{
    font-size:12px;
  }
  .font-d2{
    font-size: 16px;
  }
  .top-bar{
    height: 100px;
    .logo{
      height: 60px;
    }
  }
  .tit1{
    margin: 20px auto;
  }
  .box{
    border-radius: 14px;
    margin-bottom: 20px;
    .tit{
      border-radius: 10px 10px 0 0;
      padding: 10px 20px;
    }
    .title2{
      margin: 10px 20px;
    }
    .btn{
      border-radius: 10px;
      height: 40px;
      line-height: 40px;
      margin: 4px;
      padding: 0 10px;
    }
    .tag{
      margin: 0px;
      width: 200px;
      text-align: center;
      margin: 0 20px;
    }
    .btn-con{
      margin: 10px;
      border-radius: 10px;
      padding-left: 12px;
      flex: 1;
    }
  }

}
</style>
